/** @format */

import { formatDistanceToNow } from "date-fns";
import { useEffect, useState } from "react";

export const OfflineBanner = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [lastOffline, setLastOffline] = useState<Date | null>(null);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setLastOffline(null);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setLastOffline(new Date());
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Initial state is already set in useState, no need to set it here

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOnline) {
    return null;
  }

  const timeAgo = lastOffline
    ? formatDistanceToNow(lastOffline, { addSuffix: true })
    : "earlier";

  return (
    <div className="fixed top-0 left-0 right-0 bg-yellow-600 text-black px-4 py-2 text-center z-50 font-medium">
      ⚠️ You are offline. Showing cached data from {timeAgo}.
    </div>
  );
};
